export default __webpack_public_path__ + "static/char-v-20-954f1c80086de205ddcd31fc08c9c7ae.webp";